/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPrinter: {
  name: 'printer';
  data: string;
} = {
  name: 'printer',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3A1.5 1.5 0 0 1 5 1.5h6A1.5 1.5 0 0 1 12.5 3v1.5H14A1.5 1.5 0 0 1 15.5 6V12a1.5 1.5 0 0 1-1.5 1.5h-1.5v.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-.5H2A1.5 1.5 0 0 1 .5 12V6A1.5 1.5 0 0 1 2 4.5h1.5V3Zm1 1.5h7V3a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v1.5Zm0 8.505a.417.417 0 0 0 0-.01V11.5h7v2h-7v-.495Zm-1-.505H2a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-.5.5h-1.5V11a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v1.5Z" fill="currentColor"/></svg>`,
};
